import React from 'react';
import { Heart, TrendingUp, Award, Shield } from 'lucide-react';
import { JESSICA_PHOTO, SERVICE_AREAS, ABOUT_ME_PARAGRAPHS, ABOUT_ME_CLOSER } from '../../constants/site';

const ABOUT_FEATURES = [
  { icon: Heart, title: 'Personal Touch', desc: 'Every client receives dedicated, personalized service' },
  { icon: TrendingUp, title: 'Market Expertise', desc: 'Deep knowledge of coastal VA & NC real estate markets' },
  { icon: Award, title: 'Proven Results', desc: '500+ successful transactions and counting' },
  { icon: Shield, title: 'Your Advocate', desc: 'Protecting your interests at every step' },
];

const AboutFeature = ({ item }) => (
  <div className="flex items-start space-x-4 p-4 rounded-lg hover:bg-sand-100 transition-colors">
    <div className="w-12 h-12 bg-sand-200 rounded-lg flex items-center justify-center flex-shrink-0">
      <item.icon className="w-6 h-6 text-neutral-700" />
    </div>
    <div>
      <h3 className="font-semibold text-neutral-900 mb-1">{item.title}</h3>
      <p className="text-sm text-neutral-600">{item.desc}</p>
    </div>
  </div>
);

export const AboutSection = () => (
  <section id="about" className="py-16 sm:py-24 bg-sand-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
            <img src={JESSICA_PHOTO} alt="Jessica Burnette" className="w-full h-full object-cover" loading="lazy" decoding="async" />
          </div>
          <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-sand-100 rounded-2xl -z-10"></div>
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <div className="inline-block px-4 py-2 bg-sand-200 rounded-full"><span className="text-sm font-medium text-neutral-700">About Me</span></div>
            <h2 className="text-4xl sm:text-5xl font-serif text-neutral-900 leading-tight">Your Coastal Virginia &amp; North Carolina Real Estate Expert</h2>
            <div className="space-y-4 text-neutral-600 leading-relaxed" data-testid="about-me-copy">
              {ABOUT_ME_PARAGRAPHS.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
              <p className="font-bold text-[#143160]" data-testid="about-me-closer">{ABOUT_ME_CLOSER}</p>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-6 pt-6">
            {ABOUT_FEATURES.map((item) => <AboutFeature key={item.title} item={item} />)}
          </div>
          <div className="pt-6 border-t border-neutral-200">
            <h3 className="font-semibold text-neutral-900 mb-4">Serving These Areas:</h3>
            <div className="flex flex-wrap gap-2">
              {SERVICE_AREAS.map((area) => (
                <span key={area} className="px-4 py-2 bg-sand-200 text-neutral-700 rounded-full text-sm hover:bg-neutral-200 transition-colors">{area}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
